// extracted by mini-css-extract-plugin
export default {"wrapper":"W2-z","play":"X2-z"};